export const helpOverlayStyles = {
  root: "flex min-h-0 flex-1 flex-col overflow-hidden",
  header: "flex shrink-0 items-center gap-2 border-b border-panel-border bg-info-surface px-3 py-2",
  headerIcon: "h-3.5 w-3.5 shrink-0 text-info",
  headerTitle: "min-w-0 flex-1 text-xs font-medium text-secondary-foreground",
  body: "flex-1 overflow-y-auto bg-panel",
  bodyInner: "flex flex-col gap-4 px-4 py-4",
  intro: "text-xxs leading-relaxed text-muted-foreground",
  sectionLabel: "mb-2 text-2xs font-semibold uppercase tracking-widest text-subtle",
  capabilitiesList: "divide-y divide-secondary rounded-xl border border-muted bg-white shadow-sm",
  capabilityItem: "px-3 py-2.5",
  capabilityTitle: "text-xs font-semibold text-foreground",
  capabilityDesc: "mt-0.5 text-2xs leading-relaxed text-subtle",
  tipList: "flex flex-col gap-1",
  tipItem: "flex items-start gap-2 py-0.5",
  tipBullet: "mt-0.5 shrink-0 text-2xs text-dim",
  tipText: "text-xxs leading-relaxed text-muted-foreground",
  notSupportedText: "text-xxs text-subtle",
  statusRow: "flex items-center gap-1.5 pt-1",
  statusDot: "h-1.5 w-1.5 rounded-full bg-online",
  statusLabel: "text-2xs text-dim",
};
